// Copyright (c) Bentley Systems
import { Svg404 } from "@itwin/itwinui-illustrations-react";
import { NonIdealState } from "@itwin/itwinui-react";
const NoPage = () => {
  return (
    <div>
      <NonIdealState
        description={
          <>
            We can not find the page that you are looking for or it does not
            exist.
            <br />
            Contact our support team for assistance.
          </>
        }
        heading="Page not found"
        svg={<Svg404 />}
      />
    </div>
  );
};

export default NoPage;
